export default "__VITE_ASSET__BG5ee_OM__"